import classnames from 'classnames';
import React from 'react';

import './PricingTable.scss';

export interface Props {
  additionalClass?: string;
}

export const PricingTable: React.FC<Props> = ({
  children,
  additionalClass,
}): JSX.Element => {
  return (
    <div
      className={classnames('PricingTable', {
        [additionalClass]: additionalClass,
      })}
    >
      {children}
    </div>
  );
};
